export default __webpack_public_path__ + "static/logo-over-blue-600x360-f0293087f6c5e640eca1c4815b0c1038.png";